<template>
  <div class="text-center">
    <p class="q-ma-none text-bold price">${{ data.transport.totalPrice }}</p>
    <p
      class="q-ma-none text-red text-bold text-uppercase"
      v-if="data.transport.fullPay"
    >
      Full pay
    </p>
  </div>
</template>
<script>
export default {
  name: 'AppQuotePrice',
  props: ['data']
};
</script>
<style scoped>
.price {
  color: #006029;
  font-size: 1.2em;
}
</style>
